// ============================ plugin import ====================== //
import React,{useEffect} from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';

// ============================ module import ===================== //
import { MenuComponent } from '../assets/ts/components/MenuComponent';
import { PageDataProvider } from './core/PageData';

// ============================ component import ===================== //
import Footer from './components/footer/Footer';
import DevHeaderWrapper from './components/developer-header/DevHeaderWrapper';
import Sidebar from './components/developer-sidebar/Sidebar';

const DeveloperLayout = () => {

    const location = useLocation()
    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization()
        }, 500);
    }, [location.key])


    return (
        <>
            <PageDataProvider>
                <ToastContainer/>
                <div className='d-flex flex-column flex-root app-root' id='sai_app_root'>
                    <div className='app-page flex-column flex-column-fluid' id='sai_app_page'>
                        <DevHeaderWrapper />
                        <div className='app-wrapper flex-column flex-row-fluid' id='sai_app_wrapper'>
                            <Sidebar />
                            <div className='d-flex flex-column flex-row-fluid vh-90' id='sai_app_main'>
                                <div className='d-flex flex-column flex-column-fluid flex-grow-1'>
                                    <div id="sai_app_content" className="app-content flex-column-fluid">
                                        <div id="sai_app_content_container" className="app-container container-xxl">
                                            <Outlet />
                                        </div>
                                    </div>
                                </div>
                                <Footer />
                            </div>
                        </div>
                    </div>
                </div>
            </PageDataProvider>
        </>
    )
}

export default DeveloperLayout